/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Code indicating how rare or common a prize is. This is intentionally decoupled from the actual statistical
 * distribution of a prize and is left to the user to define.
 * 
 * Code prefixes: R = Rare, C = Common, N = Non-winning. Within each prefix 1 is the rarest and higher numbers are more
 * common.
 * @export
 */
export const RarityCode = {
    _11184809: '11184809',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    C1: 'C1',
    C2: 'C2',
    C3: 'C3',
    N1: 'N1',
    unknown_default_open_api: '11184809'
} as const;
export type RarityCode = typeof RarityCode[keyof typeof RarityCode];


export function instanceOfRarityCode(value: any): boolean {
    for (const key in RarityCode) {
        if (Object.prototype.hasOwnProperty.call(RarityCode, key)) {
            if (RarityCode[key as keyof typeof RarityCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RarityCodeFromJSON(json: any): RarityCode {
    return RarityCodeFromJSONTyped(json, false);
}

export function RarityCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RarityCode {
    return json as RarityCode;
}

export function RarityCodeToJSON(value?: RarityCode | null): any {
    return value as any;
}

